<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">اشتراكات باقات الصيانة</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/mPackages">باقات الصيانة</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">الاشتراكات</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <div class="container-fluid">
        <div class="row">
          <div class="col">
            <div class="card card-secondary card-outline mb-4 mt-4">
              <div class="card-header"><div class="card-title">الاشتراكات ({{ countRows }})</div></div>
              <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />

              <div class="card-body">
                <!-- Filters -->
                <div class="row mb-3">
                  <div class="col-12 col-md-2 mb-2">
                    <input type="text" v-model="filterMobile" class="form-control" placeholder="جوال العميل">
                  </div>
                  <div class="col-12 col-md-2 mb-2">
                    <select v-model="filterStatus" class="form-control">
                      <option value="">كل الحالات</option>
                      <option v-for="(label, key) in statusChoices" :key="key" :value="key">{{ label }}</option>
                    </select>
                  </div>
                  <div class="col-12 col-md-2 mb-2">
                    <select v-model="filterPackage" class="form-control">
                      <option value="">كل الباقات</option>
                      <option v-for="pkg in packagesList" :key="pkg.id" :value="pkg.id">{{ pkg.title }}</option>
                    </select>
                  </div>
                  <div class="col-6 col-md-2 mb-2">
                    <input type="date" v-model="filterDateFrom" class="form-control" title="من تاريخ">
                  </div>
                  <div class="col-6 col-md-2 mb-2">
                    <input type="date" v-model="filterDateTo" class="form-control" title="إلى تاريخ">
                  </div>
                  <div class="col-12 col-md-2 mb-2">
                    <button class="btn btn-secondary me-2" @click="applyFilter()">بحث</button>
                    <button class="btn btn-light" @click="resetFilter()">إلغاء</button>
                  </div>
                </div>

                <mainLoader v-if="mainLoading" />
                <div v-else class="table-responsive">
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>العميل</th>
                        <th>الجوال</th>
                        <th>الباقة</th>
                        <th>السعر</th>
                        <th>الاستخدام</th>
                        <th>تاريخ البداية</th>
                        <th>تاريخ الانتهاء</th>
                        <th>الحالة</th>
                        <th>العمليات</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="row in rows" :key="row.id">
                        <td>{{ row.id }}</td>
                        <td>{{ row.User? row.User.name : '-' }}</td>
                        <td>{{ row.User? row.User.mobile : '-' }}</td>
                        <td>{{ row.title }}</td>
                        <td>{{ row.price }} ر.س</td>
                        <td>
                          <span class="badge bg-info">
                            {{ row.usedVisits }} / {{ row.visitsCount }}
                          </span>
                        </td>
                        <td>{{ row.startDate? $shortDate(row.startDate) : '-' }}</td>
                        <td>{{ row.expireDate? $shortDate(row.expireDate) : '-' }}</td>
                        <td>
                          <span :class="statusClass(row.status)">
                            {{ statusChoices[row.status] ?? row.status }}
                          </span>
                        </td>
                        <td>
                          <router-link :to="`/packagesSubscriptions/update/${row.id}`" class="btn btn-light btn-sm">
                            <i v-if="checkAccess('packages_subscriptions_update')" class="bi bi-pencil-square"></i>
                            <i v-else class="fa-regular fa-eye"></i>
                          </router-link>
                        </td>
                      </tr>
                      <tr v-if="!rows.length">
                        <td colspan="10" class="text-center text-muted">لا توجد اشتراكات</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="card-footer">
                <div class="row">
                  <div class="col">
                    <ul class="pagination">
                      <li v-if="currentPage > 1" class="page-item"><a class="page-link" href="#" @click.prevent="prevPage()">السابق</a></li>
                      <li v-for="p in pages" :key="p" class="page-item">
                        <a v-if="p == currentPage" class="page-link active" href="javascript:void(0)">{{ p }}</a>
                        <a v-else class="page-link" href="javascript:void(0)" @click="goToPage(p)">{{ p }}</a>
                      </li>
                      <li v-if="rows.length >= 30" class="page-item"><a class="page-link" href="#" @click.prevent="nextPage()">التالي</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import { checkAccess } from '@/helpers/tools';

export default {
  name: 'PackagesSubscriptionsList',
  data(){
    return {
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rows: [],
      pages: [],
      currentPage: 1,
      countRows: 0,
      statusChoices: {},
      packagesList: [],
      filterMobile: '',
      filterStatus: '',
      filterPackage: '',
      filterDateFrom: '',
      filterDateTo: '',
    }
  },
  methods: {
    checkAccess,
    statusClass(status){
      const classes = {
        active: 'badge bg-success',
        expired: 'badge bg-secondary',
        canceled: 'badge bg-danger',
        waiting_payment: 'badge bg-warning',
        payment_issue: 'badge bg-danger',
        exceeded: 'badge bg-dark',
      };
      return classes[status] ?? 'badge bg-secondary';
    },
    getPackages(){
      this.$http.get('/api/admin/mPackages/list').then(({data}) => {
        this.packagesList = data.rows ?? [];
      }).catch(() => {});
    },
    getList(){
      this.mainLoading = true;
      this.hasError = false;
      let url = `/api/admin/mPackages/subscriptions/list?page=${this.currentPage}`;
      if(this.filterMobile)
        url += `&mobile=${encodeURIComponent(this.filterMobile)}`;
      if(this.filterStatus)
        url += `&status=${this.filterStatus}`;
      if(this.filterPackage)
        url += `&packageId=${this.filterPackage}`;
      if(this.filterDateFrom && this.filterDateTo)
        url += `&dateFrom=${this.filterDateFrom}&dateTo=${this.filterDateTo}`;

      this.$http.get(url).then(({data}) => {
        this.rows = data.rows;
        this.pages = data.pages ?? [this.currentPage];
        this.countRows = data.countRows ?? 0;
        this.statusChoices = data.statusChoices ?? {};
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        this.mainLoading = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    applyFilter(){
      this.currentPage = 1;
      this.getList();
    },
    resetFilter(){
      this.filterMobile = '';
      this.filterStatus = '';
      this.filterPackage = '';
      this.filterDateFrom = '';
      this.filterDateTo = '';
      this.currentPage = 1;
      this.getList();
    },
    nextPage(){
      this.currentPage += 1;
      this.getList();
    },
    prevPage(){
      this.currentPage -= 1;
      this.getList();
    },
    goToPage(num){
      this.currentPage = num;
      this.getList();
    },
  },
  created(){
    this.getList();
    this.getPackages();
  }
}
</script>